module.exports = __webpack_public_path__ + "static/media/mtn50.eb820be5.geojson";